import { Navigate } from "react-router-dom"
import { getItemFromLocalStorage } from "utils/localStorage"

const Login = () => {
  const token = getItemFromLocalStorage("token")

  if (token) {
    return <Navigate to="dashboard" />
  } else {
    return <Navigate to="login" />
  }
}

export default Login
